import React from "react";
import Button from "react-bootstrap/Button";
import TextTheme from "components/General/Text/TextTheme";
import "./TwoButtonLayout.css";

class TwoButtonLayout extends React.Component {
  render() {
    return (
      <div
        className="two_button_div"
        style={{
            display: "flex"
        }}
      >
        <Button
          className="two_button_left_button"
          style={{
            borderColor: "#FF6342",
            backgroundColor: "white",
            color: "#FF6342",
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderTopLeftRadius: "6px",
            borderBottomLeftRadius: "6px",
          }}
          size="lg"
          disabled={this.props.disabled}
          onClick={this.props.button1Click}
        >
          <b>
            <TextTheme
              message={this.props.button1Text + " "}
              className="text_small"
            />
          </b>
        </Button>
        <Button
          className="two_button_right_button"
          style={{
            backgroundColor: "#FF6342",
            borderColor: "#FF6342",
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderTopRightRadius: "6px",
            borderBottomRightRadius: "6px",
          }}
          disabled={this.props.disabled}
          size="lg"
          onClick={this.props.button2Click}
        >
          <b>
            <TextTheme
              message={this.props.button2Text + " "}
              className="text_small text_white"
            />
          </b>
        </Button>
      </div>
    );
  }
}

export default TwoButtonLayout;